import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { EmptyState } from "../components/EmptyState";
import { fmtDate } from "../lib/format";

export default function Customers() {
  const nav = useNavigate();
  const [data, setData] = useState({ items: [], total: 0 });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const shouldFetch = search.trim().length > 0;

  useEffect(() => {
    if (!shouldFetch) { setData({ items: [], total: 0 }); return; }
    setLoading(true);
    api.get("/admin/customers", { params: { page, per_page: 25, search: search.trim() } })
      .then((r) => setData({ items: r.data.items || [], total: r.data.total || 0 }))
      .finally(() => setLoading(false));
  }, [search, page, shouldFetch]);

  const columns = [
    { key: "full_name", header: "Customer", render: (r) => <div><div className="font-medium" data-testid={`customer-name-${r.id}`}>{r.full_name}</div><div className="text-xs text-muted-foreground">{r.email}</div></div> },
    { key: "handle", header: "Handle", render: (r) => r.handle || <span className="text-muted-foreground">—</span> },
    { key: "phone", header: "Phone", render: (r) => r.phone || <span className="text-muted-foreground">—</span> },
    { key: "location", header: "Location", render: (r) => [r.preferred_location, r.preferred_country].filter(Boolean).join(" · ") || <span className="text-muted-foreground">—</span> },
    { key: "currency", header: "Preferred currency", render: (r) => r.preferred_currency || <span className="text-muted-foreground">—</span> },
    { key: "created_at", header: "Joined", render: (r) => <span className="text-xs text-muted-foreground">{fmtDate(r.created_at)}</span> },
  ];

  return <div data-testid="customers-page">
    <PageHeader title="Customers" description="Search customer account records by name, email, or handle." />
    <div className="pt-6">
      {!shouldFetch ? <div className="space-y-3"><div className="max-w-sm"><input type="text" value={search} onChange={(e) => { setSearch(e.target.value); setPage(1); }} placeholder="Search name, email, handle…" className="w-full h-9 text-sm rounded-md border border-input bg-background px-3 py-1" data-testid="customers-search-input" /></div><EmptyState icon={Search} title="Search to begin" description="Customer account records load on demand." testId="customers-empty" /></div> : <DataTable columns={columns} rows={data.items} total={data.total} page={page} pageSize={25} loading={loading} onPageChange={setPage} searchValue={search} onSearchChange={(v) => { setSearch(v); setPage(1); }} searchPlaceholder="Search name, email, handle…" onRowClick={(r) => nav(`/customers/${r.id}`)} emptyTitle="No customers match" emptyDescription="Try a different search term." testIdPrefix="customers" />}
    </div>
  </div>;
}
